/**
 * Track last-viewed products in localStorage (Smootify-compatible pattern).
 *
 * - `lmdr_last_viewed` : JSON array de handles produit, plus récent en 1er.
 * - Cap à 20 handles pour éviter que localStorage gonfle.
 * - Dédoublonné : re-visiter un handle le pousse en tête de liste.
 *
 * RGPD : la personnalisation "produits récemment vus" est NON-essentielle
 * → l'écriture est gated par `preferencesAllowed()` (consent Shopify
 * Customer Privacy). Sans consent → pas d'écriture localStorage. La
 * lecture (getLastViewedHandles) reste OK car elle ne pose pas de cookie
 * et n'affiche que ce qui était déjà stocké avant le retrait du consent.
 */

import { preferencesAllowed } from "../i18n/consent.js";

const KEY = "lmdr_last_viewed";
const MAX = 20;

export function getLastViewedHandles(): string[] {
  if (typeof localStorage === "undefined") return [];
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((h): h is string => typeof h === "string" && h.length > 0);
  } catch {
    return [];
  }
}

export function pushLastViewed(handle: string): void {
  if (typeof localStorage === "undefined" || !handle) return;
  if (!preferencesAllowed()) return; // RGPD : pas de tracking sans consent
  try {
    const list = getLastViewedHandles().filter((h) => h !== handle);
    list.unshift(handle);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* noop */
  }
}
